import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';

export const getDisciplineFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.disciplines.code.label',
      contentValue: `{{ ${entity}discipline.code }}`,
      description: 'templates.disciplines.code.description',
    },
    {
      label: 'templates.disciplines.name.label',
      contentValue: `{{ ${entity}discipline.name }}`,
      description: 'templates.disciplines.name.description',
    },
    {
      label: 'templates.disciplines.short_name.label',
      contentValue: `{{ ${entity}discipline.short_name }}`,
      description: 'templates.disciplines.short_name.description',
    },
    {
      label: 'templates.disciplines.status.label',
      contentValue: `{{ ${entity}discipline.status }}`,
      description: 'templates.disciplines.status.description',
    },
    {
      label: 'templates.disciplines.color.label',
      contentValue: `{{ ${entity}discipline.color }}`,
      description: 'templates.disciplines.color.description',
    },
    // {
    //   label: 'templates.disciplines.icon.label',
    //   contentValue: `{{ ${entity}discipline.icon }}`,
    //   description: 'templates.disciplines.icon.description',
    // },
    // {
    //   label: 'templates.disciplines.ordering.label',
    //   contentValue: `{{ ${entity}discipline.ordering }}`,
    //   description: 'templates.disciplines.ordering.description',
    // },
    // {
    //   label: 'templates.disciplines.favorite.label',
    //   contentValue: `{{ ${entity}discipline.favorite }}`,
    //   description: 'templates.disciplines.favorite.description',
    // },
    // {
    //   label: 'templates.disciplines.enable_online_booking.label',
    //   contentValue: `{{ ${entity}discipline.enable_online_booking }}`,
    //   description: 'templates.disciplines.enable_online_booking.description',
    // },
    {
      label: 'templates.disciplines.number_of_players.label',
      contentValue: `{{ ${entity}discipline.number_of_players }}`,
      description: 'templates.disciplines.number_of_players.description',
    },
    {
      label: 'templates.disciplines.short_description.label',
      contentValue: `{{ ${entity}discipline.short_description }}`,
      description: 'templates.disciplines.short_description.description',
    },
    // {
    //   label: 'templates.disciplines.published.label',
    //   contentValue: `{{ ${entity}discipline.published }}`,
    //   description: 'templates.disciplines.published.description',
    // },
    // {
    //   label: 'templates.disciplines.publish_start_date_time.label',
    //   contentValue: `{{ ${entity}discipline.publish_start_date_time }}`,
    //   description: 'templates.disciplines.publish_start_date_time.description',
    // },
    // {
    //   label: 'templates.disciplines.publish_end_date_time.label',
    //   contentValue: `{{ ${entity}discipline.publish_end_date_time }}`,
    //   description: 'templates.disciplines.publish_end_date_time.description',
    // },
    {
      label: 'templates.disciplines.content.label',
      contentValue: `{{ ${entity}discipline.content }}`,
      description: 'templates.disciplines.content.description',
    },
    {
      label: 'templates.disciplines.alias.label',
      contentValue: `{{ ${entity}discipline.alias }}`,
      description: 'templates.disciplines.alias.description',
    },
  ];
};

export const templateDiscipline: EntityTemplateVariables = {
  fields: getDisciplineFieldsForEntity(''),
  related: [],
  relatedInLoop: [],
};
